export default "images/logo.png";